import styles from 'styles/FilterButtons.module.css';
import { NewsLabelData } from 'interfaces/news';

const FilterButtons = ({ labels, selectedLabel, setSelectedLabel, setCurrentPage }: { labels: NewsLabelData[]; selectedLabel: string; setSelectedLabel: (label: string) => void; setCurrentPage: (page: number) => void; }) => {
  return (
    <div className={styles["button-container"]}>
      {labels.map((label) => (
        <button
          className={styles["view-all-button"]}
          key={label.newsLabel}
          onClick={() => {
            setSelectedLabel(label.newsLabel);
            setCurrentPage(1);
          }}
          style={{
            border: selectedLabel === label.newsLabel ? '1.5px solid #bf0178' : '1.5px solid #333',
            color: selectedLabel === label.newsLabel ? '#bf0178' : '#333',
          }}
        >
          {label.newsLabel}
        </button>
      ))}
    </div>
  );
};

export default FilterButtons;
